module.exports = __webpack_public_path__ + "img/logo5.5f2d78bb.jpg";